import { WebEDIAnnotation } from './types';

export const mergeNavigableItems = (
  formItems: Array<WebEDIAnnotation>,
  annotationItems: Array<WebEDIAnnotation>,
): Array<WebEDIAnnotation> => {
  return [...formItems, ...annotationItems];
};
